<template>
  <div>
    <el-card class="mat12">
      <el-row>
        <!-- <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="project">
          <h4 class="flex_shrink">项目编号：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{project.projectCode}}</span>
        </el-col> -->
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="project">
          <h4 class="flex_shrink">项目名称：</h4>
          <span class="ellipsis">{{project.projectName}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="isMonth">
          <h4 class="flex_shrink">月份：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{month}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class">
          <h4 class="flex_shrink">部门：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.deptName}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class">
          <h4 class="flex_shrink">经办人：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.transactor}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class">
          <!-- <h4 class="flex_shrink">提交时间：</h4> -->
          <h4 class="flex_shrink">时间：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.addTime}}</span>
        </el-col>
      
      </el-row>
      <el-row class="media_col padding-tb10 flex_class">
           <el-col :span="6" class="media_col padding-tb10 flex_class">
          <h4 class="flex_shrink">事项：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.matter}}</span>
           </el-col>
            <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.matter == '提交发票'">
          <h4 class="flex_shrink">发票金额：</h4>
          <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.invoiceAmount?dataDesc.invoiceAmount:0}}元</span>
        </el-col>
        </el-row>
      <el-row class="media_col padding-tb10 flex_class" v-if="dataDesc.detailContent">
        <h4 class="flex_shrink">工作详情：</h4>
        <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.detailContent}}</span>
      </el-row>
      <el-row class="media_col padding-tb10 flex_class">
        <h4 class="flex_shrink">备注：</h4>
        <span :class="{'ellipsis':$store.getters.tagView}">{{dataDesc.remark?dataDesc.remark:'无'}}</span>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CardProcessInfo',
  props: {
    dataDesc: {
      type: Object,
      default: () => {}
    },
    project: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      items1: [],
      items2: [],
      month: '' // 月份
    }
  },
  created () {
    this.dataDesc.items.map(item => {
      // 处理直入直出
      if (item.type == 1) {
        this.items1.push(item)
      } else {
        this.items2.push(item)
      }
    })
    // 处理月份
    if (this.dataDesc.month) {
      let data = this.dataDesc.month
      let month = data.split('-')
      this.month = month[0] + '年' + month[1] + '月'
    } else {
      this.month = this.dataDesc.month
    }
  },
  computed: {
    // 收入总
    totalCost1 () {
      let total = 0
      this.items1.forEach(item => {
        total += Number(item.cost)
      })
      return total || 0
    },
    // 总支出
    totalCost2 () {
      let total = 0
      this.items2.forEach(item => {
        total += Number(item.cost)
      })
      return total || 0
    },
    // 是否显示月份
    isMonth () {
      if (this.dataDesc.matter == '提交考勤') {
        return true
      }
      if (this.dataDesc.matter == '提交发票') {
        return true
      }
      if (this.dataDesc.matter == '催收服务费') {
        return true
      }
      if (this.dataDesc.matter == '服务费到账') {
        return true
      }
      if (this.dataDesc.matter == '发放工资') {
        return true
      }
      if (this.dataDesc.matter == '支付房租') {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
$red_color: #ff0000;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}
.money_box {
  margin-right: 20px;
  .line {
    margin: 0 2px;
  }
}
.red {
  color: $red_color;
}
</style>
